export default "<a type=\"button\" (click)=\"invokeOpen()\" class=\"openLink\">\n  {{ name }}\n</a>\n";